import React from 'react';
import { formatPct } from './utils';
import PadraoInfoButton from './PadraoInfoButton';

const PatternTable = ({ color, title, padroes, onShowPadraoInfo }) => {
    let totalEmp = 0;
    let totalLancada = 0;
    let totalFinal = 0;

    return (
        <table className="table table-striped table-condensed table-padroes" style={{ border: `3px solid ${color}` }}>
            <thead>
                <tr className="text-center" style={{ backgroundColor: color, color: '#fff' }}>
                    <td colSpan="8"><span>{title}</span></td>
                </tr>
                <tr className="text-center" style={{ backgroundColor: color, color: '#fff' }}>
                    <th className="text-center" style={{ color: '#fff', padding: 7 }}>
                        Padrão
                        <PadraoInfoButton title={title} color={color} onShow={onShowPadraoInfo} />
                    </th>
                    <th className="text-center" style={{ color: '#fff', padding: 7 }}>Nº Emp</th>
                    <th className="text-center" style={{ color: '#fff', padding: 7 }}>(%)</th>
                    <th className="text-center" style={{ color: '#fff', padding: 7 }}>Oferta Lançada</th>
                    <th className="text-center" style={{ color: '#fff', padding: 7 }}>(%)</th>
                    <th className="text-center" style={{ color: '#fff' }}>Oferta Final</th>
                    <th className="text-center" style={{ color: '#fff' }}>(%)</th>
                    <th className="text-center" style={{ color: '#fff' }}>Dispo. s/O.I</th>
                </tr>
            </thead>
            <tbody>
                {padroes.map((p, i) => {
                    totalEmp += parseInt(p.count);
                    totalLancada += parseInt(p.oferta_inicial);
                    totalFinal += parseInt(p.oferta_final);
                    return (
                        <tr className="text-center" key={i}>
                            <td>{p.padrao}</td>
                            <td>{p.count}</td>
                            <td>{formatPct(p.porcentagem_empreendimentos)}</td>
                            <td>{Number(p.oferta_inicial).toLocaleString()}</td>
                            <td>{formatPct(p.oferta_inicial_porcentagem)}</td>
                            <td>{Number(p.oferta_final).toLocaleString()}</td>
                            <td>{formatPct(p.oferta_final_porcentagem)}</td>
                            <td>{formatPct(p.oferta_final_porcentagem_sob_oferta_inicial)}</td>
                        </tr>
                    );
                })}
            </tbody>
            <tfoot>
                <tr>
                    <td className="text-center">Total</td>
                    <td className="text-center">{totalEmp.toLocaleString('pt-BR')}</td>
                    <td className="text-center">100%</td>
                    <td className="text-center">{totalLancada.toLocaleString('pt-BR')}</td>
                    <td className="text-center">100%</td>
                    <td className="text-center">{totalFinal.toLocaleString('pt-BR')}</td>
                    <td className="text-center">100%</td>
                    <td className="text-center">{totalLancada > 0 ? formatPct((totalFinal / totalLancada) * 100) : '0,0'}</td>
                </tr>
            </tfoot>
        </table>
    );
};

export default PatternTable;
